<template>
    <div class="card blkd">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col red">
              <h3><i class="fas fa-ban"></i>Blocked Cusip</h3>
            </div>
            <div class="text-right">
              <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> View All</a>
            </div>
        </div>
      </div>
      <div class="card-body">
        <ul class="cusip">
            <span v-if="cusips.length == 0 ">There is no blocked cusip</span>
            <li v-for="cusip in cusips" :key="cusip.id">{{cusip}}</li>
        </ul>
        <footer>
            <div class="redb">
              <i class="fas fa-ban"></i>
              <span>{{totalCusipsBlocked}}</span> Blocked Cusip
            </div>
            <div class="greenb">
              <i class="fas fa-clipboard-list"></i>
              <span>{{totalCusips}}</span> Total Cusip
            </div>
        </footer>
      </div>
  </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";

export default {
  name: "bockedcusip",
  data() {
    return {
      accessToken:null,
      cusips:[],
      totalCusipsBlocked : 0,
      totalCusips : 0
    };
  },
  methods: {
    getBlockedCusips() {
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + '/cusip/counts?type=BID',
            auth

        )
        .then(result => {
          this.totalCusips = result.data.total;
          this.totalCusipsBlocked = result.data.blocked;
          this.cusips = result.data.blockedCusips;

        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    navigateListPage(){
      window.location.href = "/bidside/admin-managecusips";
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getBlockedCusips();
      }
    }); 
  }
};
</script>